import { SagaIterator } from '@redux-saga/core';
import { takeLatest } from '@redux-saga/core/effects';
import { UploadFilesBwListUpdate } from '../reducer';
import { workerFetchFiles } from './workers';

export default function* watchBwListUpdate(): SagaIterator {
  yield takeLatest(UploadFilesBwListUpdate, workerFetchFiles);
}
